import React from 'react'
import { Icon } from 'antd'
import './styles.scss'

export default ({ icon, name, value }) => (
  <div className='transfer-stats'>
    <div className='transfer-stats-body'>
      <div className='stats-icon'>
        <Icon type={icon} />
      </div>
      <div className='stats-info'>
        <span className='stats-name'>
          {name}
        </span>
        <span className='stats-value'>
          {value}
        </span>
      </div>
    </div>
    <div className='transfer-stats-footer'>
      <Icon type='sync' /> Updated now
    </div>
  </div>
)
